import React, { useEffect, useState } from 'react';
import { Box, Button, Modal, Paper, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { myContainerStyle } from '../../../configs/ui/constant';
import MaterialTable from 'material-table';
import dayjs from 'dayjs';
import {
   headerStyle,
   tableIcons,
   tableStyle,
} from '../../../configs/ui/TableConfig';
import Axios from 'axios';
import { StatusLabel } from '../../../components/Status/StatusLabel';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
   faFileEdit,
   faHistory,
   faMinusCircle,
   faPlusCircle,
   faTrashAlt,
} from '@fortawesome/pro-duotone-svg-icons';
import { faRedoAlt } from '@fortawesome/free-solid-svg-icons';
import { faPlus } from '@fortawesome/pro-light-svg-icons';
import Create from '../../../components/Modal/HrWallet/Create';
import Edit from '../../../components/Modal/HrWallet/Edit';
import Delete from '../../../components/Modal/HrWallet/Delete';
import Increase from '../../../components/Modal/HrWallet/Increase';
import Decrease from '../../../components/Modal/HrWallet/Decrease';
import { LogToBackend } from '../../../configs/helpers/LogToBackend';
import { useHistory } from 'react-router-dom';
import ViewTable from '../../../components/Modal/HrWallet/ViewTable';
import { useSnackbar } from 'notistack';

const useStyles = makeStyles((theme) => ({
   modal: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
   },
   paper: {
      display: 'flex',
      border: `1px solid ${theme.palette.divider}`,
      flexWrap: 'wrap',
   },
}));

function HrWallet(props) {
   const history = useHistory();
   const classes = useStyles();
   const [isLoading, setIsLoading] = useState(false);
   const [resp, setResp] = useState([]);
   const [data, setData] = useState([]);
   const [myModal, setMyModal] = useState('');
   const [showModal, setShowModal] = useState(false);
   const { enqueueSnackbar, closeSnackbar } = useSnackbar();

   useEffect(() => {
      getData();
   }, []);
   const getData = () => {
      setIsLoading(true);
      Axios.get('/GSB/dashboard/wallet/GetHRWalletList')
         .then((response) => {
            setResp(response.data);
         })
         .catch((e) => {
            LogToBackend(e);
            if (e.response) {
               const response = e.response.data;
               const statusCode = e.response.status;
               if (statusCode === 401) {
                  sessionStorage.clear();
                  localStorage.clear();
                  history.push('/');
               }
               enqueueSnackbar(response.errorAppMessageTh, {
                  variant: 'error',
               });
            } else console.error('site error');
         })
         .finally(() => {
            setIsLoading(false);
         });
   };
   useEffect(() => {
      setTableData();
   }, [resp]);
   const setTableData = () => {
      if (resp.length > 0) {
         const dataForMap = resp;
         const formatted = dataForMap.map((value) => {
            return Object.assign(
               {},
               {
                  ...value,
                  data: value,
               },
            );
         });
         setIsLoading(false);
         setData(formatted);
      }
   };
   const refreshData = () => {
      setShowModal(false);
      setData([]);
      getData();
   };
   const setModalStyle = (type, value) => {
      if (type === 'view') {
         setMyModal(
            <ViewTable
               onClickClose={() => setShowModal(false)}
               data={value}
               onSuccess={() => refreshData()}
            />,
         );
      }
      if (type === 'create') {
         setMyModal(
            <Create
               onClickClose={() => setShowModal(false)}
               onSuccess={() => refreshData()}
            />,
         );
      }
      if (type === 'increase') {
         setMyModal(
            <Increase
               onClickClose={() => setShowModal(false)}
               data={value}
               onSuccess={() => refreshData()}
            />,
         );
      }
      if (type === 'decrease') {
         setMyModal(
            <Decrease
               onClickClose={() => setShowModal(false)}
               data={value}
               onSuccess={() => refreshData()}
            />,
         );
      }
      if (type === 'edit') {
         setMyModal(
            <Edit
               onClickClose={() => setShowModal(false)}
               data={value}
               onSuccess={() => refreshData()}
            />,
         );
      }
      if (type === 'delete') {
         setMyModal(
            <Delete
               onClickClose={() => setShowModal(false)}
               data={value}
               onSuccess={() => refreshData()}
            />,
         );
      }
      setShowModal(!showModal);
   };

   return (
      <Paper style={myContainerStyle.root}>
         <Modal className={classes.modal} open={showModal}>
            <React.Fragment>{myModal}</React.Fragment>
         </Modal>
         <Box display='flex' my={1} alignItems='center'>
            <Box mx={1}>
               <Typography variant='h5'>จัดการกระเป๋าส่วนกลาง (HR)</Typography>
            </Box>
            <Box mx={1}>
               <Button
                  variant='contained'
                  color='primary'
                  size='small'
                  startIcon={<FontAwesomeIcon icon={faPlus} size={'xs'} />}
                  onClick={() => {
                     setModalStyle('create', '');
                  }}
               >
                  เพิ่มกระเป๋า
               </Button>
            </Box>
         </Box>
         <MaterialTable
            isLoading={isLoading}
            columns={[
               {
                  field: 'walletCode',
                  title: 'รหัสกระเป๋า',
                  width: 150,
               },
               {
                  field: 'walletStatus',
                  title: 'สถานะ',
                  width: 100,
                  filtering: false,
                  headerStyle: {
                     textAlign: 'center',
                  },
                  cellStyle: {
                     textAlign: 'center',
                  },
                  sorting: false,
                  export: false,
                  render: (rowData) => (
                     <StatusLabel
                        StatusType={rowData.walletStatus}
                        msg={rowData.walletStatusDesc}
                     />
                  ),
               },
               {
                  field: 'walletName',
                  title: 'ชื่อกระเป๋า',
                  render: (rowData) => rowData.walletNameTh,
               },
               {
                  field: 'walletDescription',
                  title: 'รายละเอียด',
                  render: (rowData) => rowData.walletDescriptionTh,
               },
               {
                  field: 'walletCurrentBalance',
                  title: 'คะแนนคงเหลือ',
                  type: 'numeric',
                  render: (rowData) =>
                     new Intl.NumberFormat().format(
                        rowData.walletCurrentBalance,
                     ),
               },
               {
                  field: 'walletUsed',
                  title: 'คะแนนที่ใช้ไป',
                  type: 'numeric',
                  render: (rowData) =>
                     new Intl.NumberFormat().format(
                        rowData.walletAllocatePoint -
                           rowData.walletCurrentBalance,
                     ),
               },
               {
                  field: 'walletAllocatePoint',
                  title: 'คะแนนตั้งต้น',
                  type: 'numeric',
                  render: (rowData) =>
                     new Intl.NumberFormat().format(
                        rowData.walletAllocatePoint,
                     ),
               },
               {
                  field: 'walletCreateDate',
                  title: 'วันที่สร้าง',
                  type: 'date',
                  render: (rowData) =>
                     dayjs(new Date(rowData.walletCreateDate)).format(
                        'DD/MM/BBBB',
                     ),
               },
               {
                  field: 'walletExpiryDate',
                  title: 'วันหมดอายุ',
                  type: 'date',
                  render: (rowData) =>
                     dayjs(new Date(rowData.walletExpiryDate)).format(
                        'DD/MM/BBBB',
                     ),
               },
            ]}
            data={data}
            options={{
               showTitle: false,
               headerStyle: headerStyle,
               padding: 'dense',
               actionsColumnIndex: -1,
               pageSize: 5,
               pageSizeOptions: [5, 10, 25, 50, 100],
            }}
            localization={{
               header: { actions: 'ตัวจัดการ' },
            }}
            style={tableStyle}
            icons={tableIcons}
            actions={[
               {
                  icon: React.forwardRef((props, ref) => (
                     <FontAwesomeIcon
                        ref={ref}
                        {...props}
                        icon={faRedoAlt}
                        size={'xs'}
                     />
                  )),
                  tooltip: 'Refresh Data',
                  isFreeAction: true,
                  onClick: () => refreshData(),
               },
               (rowData) => ({
                  icon: React.forwardRef((props, ref) => (
                     <FontAwesomeIcon ref={ref} {...props} icon={faHistory} />
                  )),
                  tooltip: 'ประวัติ',
                  onClick: (event, rowData) => setModalStyle('view', rowData),
               }),
               (rowData) => ({
                  icon: React.forwardRef((props, ref) => (
                     <FontAwesomeIcon
                        ref={ref}
                        {...props}
                        color={
                           rowData.data.walletStatus === 4 ? '#ccc' : '#22b14c'
                        }
                        icon={faPlusCircle}
                     />
                  )),
                  onClick: (event, rowData) => {
                     if (rowData.data.walletStatus === 4) {
                        return false;
                     } else {
                        setModalStyle('increase', rowData.data);
                     }
                  },
                  tooltip: 'เพิ่ม',
               }),
               (rowData) => ({
                  icon: React.forwardRef((props, ref) => (
                     <FontAwesomeIcon
                        ref={ref}
                        {...props}
                        color={
                           rowData.data.walletStatus === 4 ? '#ccc' : '#ff7f27'
                        }
                        icon={faMinusCircle}
                     />
                  )),
                  onClick: (event, rowData) => {
                     if (rowData.data.walletStatus === 4) {
                        return false;
                     } else {
                        setModalStyle('decrease', rowData.data);
                     }
                  },
                  tooltip: 'ลด',
               }),
               (rowData) => ({
                  icon: React.forwardRef((props, ref) => (
                     <FontAwesomeIcon
                        ref={ref}
                        {...props}
                        color={
                           rowData.data.walletStatus === 4 ? '#ccc' : '#00a2e8'
                        }
                        icon={faFileEdit}
                     />
                  )),
                  onClick: (event, rowData) => {
                     if (rowData.data.walletStatus === 4) {
                        return false;
                     } else {
                        setModalStyle('edit', rowData.data);
                     }
                  },
                  tooltip: 'แก้ไข',
               }),
               (rowData) => ({
                  icon: React.forwardRef((props, ref) => (
                     <FontAwesomeIcon
                        ref={ref}
                        {...props}
                        color={
                           rowData.data.walletStatus === 4 ? '#ccc' : '#ed1c24'
                        }
                        icon={faTrashAlt}
                     />
                  )),
                  onClick: (event, rowData) => {
                     if (rowData.data.walletStatus === 4) {
                        return false;
                     } else {
                        setModalStyle('delete', rowData.data);
                     }
                  },
                  tooltip: 'ลบ',
               }),
            ]}
         />
      </Paper>
   );
}

export default HrWallet;
